<template>
<div class="content-editor">
  <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
    <div class="menubar">
      <v-row align="center" justify="space-around">

        <v-btn icon @click="commands.undo">
          <v-icon>mdi-undo</v-icon>
        </v-btn>

        <v-btn icon @click="commands.redo">
          <v-icon>mdi-redo</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.bold()?'red darken-1':''" @click="commands.bold">
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.italic()?'red darken-1':''" @click="commands.italic">
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.strike()?'red darken-1':''" @click="commands.strike">

          <v-icon>mdi-format-strikethrough</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.underline()?'red darken-1':''" @click="commands.underline">
          <v-icon>mdi-format-underline</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.paragraph()?'red darken-1':''" @click="commands.paragraph">
          <v-icon>mdi-format-paragraph</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.heading({level:1})?'red darken-1':''" @click="commands.heading({level:1})">
          H1
        </v-btn>

        <v-btn icon :color="isActive.heading({level:2})?'red darken-1':''" @click="commands.heading({level:2})">
          H2
        </v-btn>

        <v-btn icon :color="isActive.heading({level:3})?'red darken-1':''" @click="commands.heading({level:3})">
          H3
        </v-btn>

        <v-btn icon :color="isActive.bullet_list()?'red darken-1':''" @click="commands.bullet_list">
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.ordered_list()?'red darken-1':''" @click="commands.ordered_list">
          <v-icon>mdi-format-list-numbered</v-icon>
        </v-btn>

        <!-- <v-btn icon :color="isActive.blockquote()?'red darken-1':''" @click="commands.blockquote">
          <v-icon>mdi-format-quote-close</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.code()?'red darken-1':''" @click="commands.code">
          <v-icon>mdi-code-tags</v-icon>
        </v-btn>

        <v-btn icon :color="isActive.code_block()?'red darken-1':''" @click="commands.code_block">
          <v-icon>mdi-code-tags</v-icon>
        </v-btn> -->

        <v-btn icon @click="commands.horizontal_rule">
          <v-icon>mdi-border-horizontal</v-icon>
        </v-btn>

        <v-btn icon @click="clickImageButton">
          <v-icon>mdi-image</v-icon>
        </v-btn>
        <input style="display: none" ref="img_input" type="file" accept="image/*" @change="selectedImage">

        <v-btn icon @click="clickYoutubeButton">
          <v-icon>mdi-youtube</v-icon>
        </v-btn>
        <v-dialog v-model="selectVideoDialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Add Video</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="selectedVideoUrl"
                label="Video URL (YouTube Only)"
                :error="selectVideoErrorMessage!=''"
                :error-messages="selectVideoErrorMessage"
                required />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red darken-1" text @click="closeVideoSelectModal">Close</v-btn>
              <v-spacer />
              <v-btn color="red darken-1" text @click="slectedVideo">Add</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-row>
    </div>
  </editor-menu-bar>

  <editor-content class="editor__content" :editor="editor" />
</div>
</template>

<script>
//import Icon from 'Components/Icon'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image,
} from 'tiptap-extensions'
import Iframe from './Iframe'
import loadImage from 'blueimp-load-image';

export default {
  name: 'ContentEditor',
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    oldContent: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      editor: new Editor({
        content: this.value,
        onUpdate: ({ state, getHTML, getJSON, transaction }) => {
          //this.value = getHTML();
          //console.log('update', getHTML());
          this.$emit('input', getHTML());
        },
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(),
          new Iframe(),
        ],
      }),
      selectVideoDialog: false,
      selectedVideoUrl: "",
      selectVideoErrorMessage: "",
    }
  },
  watch: {
    value: function(newValue, oldValue){
      if (newValue != oldValue) {
        // TODO: fix bug
        //this.editor.clearContent();
        //this.editor.setContent(newValue);
      }
    },
    selectVideoDialog: function(newValue, oldValue) {
      if (!newValue) {
        this.selectedVideoUrl = "";
        this.selectVideoErrorMessage = "";
      }
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    clearContent() {
      this.editor.clearContent();
    },
    setContent(content) {
      this.editor.setContent(content);
      this.$emit('input', this.editor.getHTML());
    },
    getContent(content) {
      return this.editor.getHTML();
    },

    clickImageButton() {
      this.$refs.img_input.click();
    },
    selectedImage(event) {
      [...event.target.files].forEach(file => {
        loadImage(
          file,
          async (canvas) => {
            const data = canvas.toDataURL(file.type);
            this.addImage(data);
          },{
            maxHeight: 650,
            maxWidth: 650,
            canvas: true
          }
        );
      })
    },
    addImage(src) {
      this.editor.commands.image({src:src});
    },

    clickYoutubeButton() {
      this.selectVideoDialog = true;
    },
    slectedVideo() {
      const result = this.addVideo();
      if (result) {
        this.selectVideoDialog = false;
      }
    },
    closeVideoSelectModal() {
      this.selectVideoDialog = false;
    },
    addVideo() {
      // Some check can be done here, like if `youtubeID` is not false.
      const youtubeID = this.parseYoutubeUrl(this.selectedVideoUrl)
      if (youtubeID) {
        this.editor.commands.iframe({
          src:`https://www.youtube.com/embed/${youtubeID}`
        });
        return true;
      } else {
        this.selectVideoErrorMessage = "URL is not valid."
        return false;
      }
    },

    parseYoutubeUrl(url) {
      // eslint-disable-next-line no-useless-escape
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    },
  }
}
</script>

<style scoped>
.editor__content >>> .ProseMirror {
  outline: 0!important;
  margin: 10px!important;
  min-height: 300px;
}

.editor__content {
  min-height: 300px;
  z-index: -1;
  border: solid;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
  border-radius: 4px;
  border-width: thin;
}

.editor__content >>> p {
  margin-bottom: 4px!important;
}

.editor__content >>> * {
  max-width: 100%;
}
</style>
